/**
 * footer.js
 * copyright © 2022 PrimeTimeConstruction
 */
import React from "react";
import facebook from "../assets/images/facebook.png";
import instagram from "../assets/images/instagram.png";
import linkedin from "../assets/images/linkedin.png";
import pinterest from "../assets/images/pinterest.png";
import { Link } from "react-router-dom";
import Home from "../pages/home";
import ContactUs from "../pages/contactUs";
import AboutUs from "../pages/aboutus";
import FaqPage from "../pages/faq";
import Leadership from "../pages/leadership";
import TermsofUse from "../pages/termsOfUse";
import Properties from "../pages/properties";
import FindUnit from "../pages/findaunit";
import NewPatersonPage from "../pages/newpatersonPage";
import ProspectiveTenants from "../pages/prospectiveTenants";
import Careers from "../pages/careers";
import "../assets/css/home.css";

function Footer() {
  //for fetching current year to show in footer
  const currentYear = new Date().getFullYear();
  return (
    <footer className="ania-footer">
      <div className="container-width">
        <div className="d-lg-flex d-md-flex justify-content-between align-items-start">
          <div className="d-lg-flex d-md-flex justify-content-between align-items-start footer-left-half">
            <div>
              <ul className="ania-quicklinks">
                <li>
                  <Link to="/properties" component={<Properties />}>
                    properties
                  </Link>
                </li>
                <li>
                  <Link to="/whypaterson" component={<NewPatersonPage />}>
                    Why Paterson
                  </Link>
                </li>
                <li>
                  <Link to="/about-us" component={<AboutUs />}>
                    About Us
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <ul className="ania-quicklinks">
              <li>
                  <Link to="/contact" component={<ContactUs />}>
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/terms-of-use" component={<TermsofUse />}>
                    Terms of Use
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              {" "}
              <div className="footer-contactus">
                <p className="title text-uppercase">contact us</p>
                <p className="email">
                  <a
                    className="footer-contact-links"
                    href="mailto:info@primetimeconstruction.com"
                  >
                    info@primetimeconstruction.com
                  </a>
                </p>
                <p className="phone">
                  phone:{" "}
                  <a className="footer-contact-links" href="tel:9735237690">
                    {" "}
                    (973) 523-7690
                  </a>
                </p>
                <p className="address last">
                  175, Broadway <br />
                  Paterson, NJ 07505
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="footer-copyright">
              <p className="copyright">
                All Rights Reserved &reg; PrimeTimeConstruction - {currentYear}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
